module.exports = __webpack_public_path__ + "static/media/ils-no-search.7f9583c8.svg";